// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapView {
    height: 450px;
    width: 65%;
    margin: 0 auto;
    margin-top: 10px;
}

.mapView__container {
    height: 100%;
}

.mapView__skeleton {
    height: 100%;
    width: 100%;
}
.mapView__fullWidth {
    width: 100%;
}
.mapView__legend {
    background-color: whitesmoke;
    border-radius: 3px;
    border: 1px solid #aaa;
    padding: 5px;
    max-height: 450px;
    overflow: auto;
}
.mapView__legendField {
    margin-bottom: 0 !important;
}

.clusterPopup {
    max-height: 900px;
}

.clusterPopup .leaflet-popup-content-wrapper {
    max-height: 500px;
    overflow-y: scroll;
}

.leaflet-tooltip.leaflet-tooltip-bottom {
    margin-top: 40px;
    margin-left: -10px;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/MapView/MapView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".mapView {\n    height: 450px;\n    width: 65%;\n    margin: 0 auto;\n    margin-top: 10px;\n}\n\n.mapView__container {\n    height: 100%;\n}\n\n.mapView__skeleton {\n    height: 100%;\n    width: 100%;\n}\n.mapView__fullWidth {\n    width: 100%;\n}\n.mapView__legend {\n    background-color: whitesmoke;\n    border-radius: 3px;\n    border: 1px solid #aaa;\n    padding: 5px;\n    max-height: 450px;\n    overflow: auto;\n}\n.mapView__legendField {\n    margin-bottom: 0 !important;\n}\n\n.clusterPopup {\n    max-height: 900px;\n}\n\n.clusterPopup .leaflet-popup-content-wrapper {\n    max-height: 500px;\n    overflow-y: scroll;\n}\n\n.leaflet-tooltip.leaflet-tooltip-bottom {\n    margin-top: 40px;\n    margin-left: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
